<template>
  <v-bottom-sheet
    :fullscreen="$vuetify.display.xsOnly"
    v-if="dontAskMeAnymore === '' && bottomSheet && isAllowed"
    v-model="bottomSheet"
    inset
  >
    <v-sheet
      height="100%"
      :class="$vuetify.display.mobile ? 'pa-3 overflow-auto': 'pa-10 overflow-auto'"
    >
      {{ $t('platform_requirements.description') }}
      <br>
      <br>
      {{ $t('platform_requirements.subtitle')}}
      <br>
      <br>
      <b>{{ $t('platform_requirements.internet_connection')}}:</b>
      {{ $t('platform_requirements.internet_connection_desc')}}
      <br>
      <br>
      <b>{{ $t('platform_requirements.supported_browsers')}}:</b>
      {{ $t('platform_requirements.supported_browsers_desc')}}
      <br>
      <br>
      <b>{{ $t('platform_requirements.camera_and_microphone')}}:</b>
      {{ $t('platform_requirements.camera_and_microphone_desc')}}
      <br>
      <br>
      <b>{{ $t('platform_requirements.hardware_requirements')}}:</b>
      {{ $t('platform_requirements.hardware_requirements_desc')}}
      <br>
      <br>
      {{ $t('platform_requirements.footer')}}
      <br>
      <div class="d-flex justify-center">
        <v-btn
          class="mt-6"
          variant="text"
          color="primary"
          @click="setCookie('dontAskMeAnymore', 'true', 365); bottomSheet = false"
        >
          {{ $t('platform_requirements.do_not_show_again') }}
        </v-btn>
        <v-btn
          class="mt-6"
          variant="text"
          color="error"
          @click="bottomSheet = false"
        >
          {{ $t('common.actions.close') }}
        </v-btn>
      </div>
      <br>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
export default {
  name: 'PlatformRequirementsBottomSheet',
  components: {},
  data() {
    return {
      bottomSheet: true,
    };
  },
  computed: {
    dontAskMeAnymore() {
      const cookieName = 'dontAskMeAnymore';
      const cookies = document.cookie.split(';');
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith(`${cookieName}=`)) {
          return cookie.substring(cookieName.length + 1);
        }
      }

      return '';
    },
    isAllowed() {
      return this.$route.name === 'learn';
    },
  },
  methods: {
    // Function to set a cookie
    setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      const expires = `expires=${date.toUTCString()}`;
      document.cookie = `${name}=${value}; ${expires}`;
    },
  },
};
</script>

<style scoped>
</style>
